// extracted by mini-css-extract-plugin
export default {"groupRow":"list_groupRow__JuBRf","note":"list_note__rA6Ib"};